import type { ReportDataTableColumn } from '../../components/ReportDataTable'
import type { ConfiguredReportReportRow } from '../../types/pages'
import { display, formatDateTime, fullName, applicantLink, statusLabel } from '../../utils/configuredReportFormatters'

export const dailyApplicationColumns: ReportDataTableColumn<ConfiguredReportReportRow, string>[] = [
  {
    id: 'property_name',
    label: 'Property',
    sortKey: 'property_name',
    render: (row) => display(row.property_name),
  },
  {
    id: 'company_name',
    label: 'Company',
    sortKey: 'company_name',
    render: (row) => display(row.company_name),
  },
  {
    id: 'applicant_name',
    label: 'Applicant Name',
    sortKey: 'applicant_name',
    render: (row) =>
      display(row.applicant_name ?? row.name) !== '—'
        ? display(row.applicant_name ?? row.name)
        : fullName(row.first_name, row.last_name),
  },
  {
    id: 'applicant_id',
    label: 'Applicant ID',
    sortKey: 'applicant_id',
    render: (row) => applicantLink(row.applicant_id),
  },
  {
    id: 'city',
    label: 'City',
    sortKey: 'property_city',
    render: (row) => display(row.city ?? row.property_city),
  },
  {
    id: 'state',
    label: 'State',
    sortKey: 'property_state',
    render: (row) => display(row.state ?? row.property_state),
  },
  {
    id: 'sales_person',
    label: 'Sales Person',
    sortKey: 'sales_person',
    render: (row) => display(row.sales_person),
  },
  {
    id: 'account_manager',
    label: 'Account Manager',
    sortKey: 'account_manager',
    render: (row) => display(row.account_manager),
  },
  {
    id: 'applicant_status',
    label: 'Applicant Status',
    sortKey: 'applicant_status',
    render: (row) => statusLabel(row.applicant_status),
  },
  {
    id: 'application_completed',
    label: 'Application Completed',
    sortKey: 'application_completed',
    render: (row) => formatDateTime(row.application_completed),
  },
]
